import styled from 'styled-components'

export default styled.h2`
  color: #303032;
  border-bottom: 2px solid #abbed1;
  margin-bottom: 16px;
  padding-bottom: 4px;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`
